import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=d506bfdc&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=js&"
export * from "./ToDo.vue?vue&type=script&lang=js&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=d506bfdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d506bfdc",
  null
  
)

export default component.exports